import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
	"inline-flex items-center rounded-md border px-2 py-1 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
	{
		variants: {
			variant: {
				default: "border-transparent bg-muted text-foreground",
				secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
				destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
				success:
					"border-transparent bg-success-soft text-success gap-1.5 before:h-1.5 before:w-1.5 before:shrink-0 before:rounded-full before:bg-current",
				warning:
					"border-transparent bg-warning-soft text-warning gap-1.5 before:h-1.5 before:w-1.5 before:shrink-0 before:rounded-full before:bg-current",
				danger: "border-transparent bg-danger-soft text-destructive gap-1.5 before:h-1.5 before:w-1.5 before:shrink-0 before:rounded-full before:bg-current",
				info: "border-transparent bg-info-soft text-info gap-1.5 before:h-1.5 before:w-1.5 before:shrink-0 before:rounded-full before:bg-current",
				violet: "border-transparent bg-violet-soft text-violet gap-1.5 before:h-1.5 before:w-1.5 before:shrink-0 before:rounded-full before:bg-current",
				orange: "border-transparent bg-orange-soft text-orange gap-1.5 before:h-1.5 before:w-1.5 before:shrink-0 before:rounded-full before:bg-current",
				outline: "text-foreground",
			},
		},
		defaultVariants: {
			variant: "default",
		},
	},
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
	return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
